/**
 * H5 使用 hash 路由。相册短码必须在 # 后面：
 * http://localhost:8080/#/photo-live/短码
 * 若短码在路径上（http://localhost:8080/photo-live/短码），
 * devServer 会把 index.html 回退出来，路由只看到 #/index，页面停在「请稍等」。
 * 这里在挂载前把路径型地址换成 hash 地址。
 * @returns {boolean} true 表示已发起跳转，调用方不要再挂载应用
 */
export function redirectLegacyPhotoLivePath() {
  if (typeof window === 'undefined' || !window.location) return false
  const path = window.location.pathname || ''
  const matched = path.match(/^\/(photo-live-upload|photo-live)\/([^/]+)\/?$/)
  if (!matched) return false
  const kind = matched[1]
  let code = matched[2]
  try {
    code = decodeURIComponent(code)
  } catch (e) {
    // 保留原始片段
  }
  const search = window.location.search || ''
  const target = window.location.origin + '/#/' + kind + '/' + encodeURIComponent(code) + search
  window.location.replace(target)
  return true
}
